import clsx from "clsx"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks"
import { Layout } from "../../../../ui/layout"
import { MenuItems } from "../../../../ui/organisms/navbar/dto"
import Button from "../../../../ui/molecules/button"
import { useState } from "react"
import { AddNewM018FormsStep1 } from "./formStep1"
import { AddNewM018FormsStep2 } from "./formStep2"
import { ArrowLeftIcon } from "../../../../ui/icons/arrow-left"

export function AddNewM018() {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const sessionState = useAppSelector(state => state.session)
    const [createProt, setCreateProt] = useState<boolean>(false)

    return (
        <Layout menuItem={MenuItems.USERS} breadcrumbItems={['Dashboard', 'Gestione Controllo', 'Crea M018']}
            noPaddingLat
            headerLabel="Crea M018"
            headerIcon={
                <button style={{ paddingTop: '12px' }} onClick={() => navigate('/customerM018')}>
                    <ArrowLeftIcon />
                </button>
            }
            headerChildren={
                <div className="flex items-center h-[100%] w-[100%] justify-end" style={{ justifyContent: 'end' }}>
                    <Button size={"sm"} iconPosition={"off"} variant={"solid"} label="Crea M018" color={"orange"}
                        disabled={!sessionState.selected.customerId}
                        onClick={() => {
                            //navigate('/addPacDetail')
                            setCreateProt(true)
                        }}
                    />
                </div>
            }
        >
            <div style={{ padding: '12px 24px 0px 24px' }}>
                {
                    !createProt && (
                        <AddNewM018FormsStep1 />
                    )
                }
                {
                    createProt && (
                        <AddNewM018FormsStep2 />
                    )
                }



            </div>

        </Layout>
    )

}